<template>
	<div class="page">
        <head-el />
		<router-view/>
        <foot-el />
	</div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import HeadEl from '@/components/head/index.vue';
    import FootEl from '@/components/foot/index.vue';

	@Component({
        components: {
            HeadEl,
            FootEl
        }
    })
	export default class App extends Vue {

	}
</script>
<style lang="scss">
    html {
        font-family: 'Microsoft YaHei, PingFangSC-Light, SimSun';
    }
    ul, li {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    p {
        margin: 0;
        padding: 0;
    }
    html, body {
        width: 100%;
        scroll-behavior: smooth;
    }
    .page {
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
    }
</style>
